// extracted by mini-css-extract-plugin
export var buttonContent = "_2j-0";
export var centered = "_2j-1";
export var centeredFlex = "_2j-2";
export var errorText = "_2j-3";
export var icon = "_2j-4";
export var iconButtonContent = "_2j-5";
export var monospace = "_2j-6";
export var padded = "_2j-7";